import clsx from 'clsx';
import type { ReactNode } from 'react';

export type ModalProps = {
  type?: 'default' | 'blue';
  children: ReactNode;
  className?: string;
};

export const Modal = ({ children, className, type = 'default' }: ModalProps) => (
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
  <div
    className={clsx(type === 'blue' ? 'modal-blue-container' : 'modal-container', className)}
    onClick={(e) => e.stopPropagation()}
  >
    {children}
  </div>
);
